import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetCountries, getCountryOperator, getMidDashboardData } from "../../api/Api";
import { getCountryOperatorData } from "../../api/Api";
import { getFromLocalStorage } from "../../utils/common-utils";
const MidCards = () => {
    const userData = getFromLocalStorage("userData");
    const [countryList, setCountryList] = useState([]);
    const [operatorData, setOperatorData] = useState([]);
    const [midDashboardData, setMidDashboardData] = useState([]);
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const navigate = useNavigate();
    const [selectedCountry, setSelectedCountry] = useState(null);

    const fetchCountryOperatorData = async () => {
      try {
        const response = await GetCountries();
        console.log("responsedd", response);
        if (response?.statusDescription?.status === 200) {
          setCountryList(response?.countryResponseList);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };
      // Function to fetch mid dashboard data
  const fetchMidDashboardData = async (filterParams) => {
    try {
      setIsFilterLoading(true); // Start loading
      const payload = {
        countryCode: filterParams.countryCode,
        operatorCode: filterParams.operatorCode,
        startDate: filterParams.startDate,
        endDate: filterParams.endDate
      };

      const response = await getMidDashboardData(payload);
      console.log("fre",response);
      if (response?.statusDescription?.status === 200) {
        setMidDashboardData(response?.dashboard);
      } else {
        console.error('Error fetching dashboard data:', response?.statusDescription?.message);
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setIsFilterLoading(false); // Stop loading
    }
  };
    const getYesterday = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0];
      };

      // Add this function to get minimum allowed date (April 18th, 2025)
  const getMinAllowedDate = () => {
    return new Date('2025-04-18').toISOString().split('T')[0];
  };

      // Function to get today's date in YYYY-MM-DD format
      const getToday = () => {
        return new Date().toISOString().split('T')[0];
      };
  // Handle any filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    let newFilters = { ...filters };
    
    if (name === 'countryCode') {
      if (value === 'All') {
        setSelectedCountry(null);
        newFilters = {
          ...newFilters,
          countryCode: 'All',
          operatorCode: 'All'
        };
      } else {
        const country = countryList.find(c => c.countryName === value);
        setSelectedCountry(country);
        newFilters = {
          ...newFilters,
          countryCode: country.cnUniId,
          operatorCode: 'All'
        };
      }
    } else if (name === 'operatorCode') {
      if (value === 'All') {
        newFilters = {
          ...newFilters,
          operatorCode: 'All'
        };
      } else {
        const operator = selectedCountry?.operatorList?.find(op => op.operatorName === value);
        newFilters = {
          ...newFilters,
          operatorCode: operator.opUniId
        };
      }
    } else {
      newFilters = {
        ...newFilters,
        [name]: value
      };
    }
    
    setFilters(newFilters);
    fetchMidDashboardData(newFilters);
  };
      // Initialize filters with yesterday's date as start date
  const [filters, setFilters] = useState({
    countryCode: "",
    operatorCode: "All",
    startDate: getMinAllowedDate(),
    endDate: getToday()
  });


    // Function to process mid dashboard data into stats format
    const processMidDashboardData = (data) => {
        if (!data || !Array.isArray(data)) return [];
    
        return data.map(item => {
          // Check if this is the Total Revenue card
          const isTotalRevenue = item.dashboardTitle === "Total Revenue";
          
          return {
            id: item.dashboardId,
            icon: isTotalRevenue ? (selectedCountry?.icon || "fas fa-dollar-sign") : item.dashboardIcon,
            title: item.dashboardTitle,
            number: item.dynamicCount,
            trend: {
              text: item.categoryText || `Total: ${item.dynamicCount == null ? 0 : item.dynamicCount}`,
              isUp: true
            },
            color: item.color,
            route: item.route,
            isImage: isTotalRevenue && selectedCountry?.icon // Only render image if we have a country icon
          };
        });
      };
      console.log("selectedCountrycc",selectedCountry)
        // Handle card click
  const handleCardClick = (route) => {
    if (route) {
      navigate(route);
    }
  };
    // Function to format numbers
    const formatNumber = (number, isCurrency = false) => {
        if (isCurrency) {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
          }).format(number);
        }
        return new Intl.NumberFormat('en-US').format(number);
      };
    
      useEffect(() => {
       fetchMidDashboardData(filters);
       fetchCountryOperatorData();
    }, []);

  // Add new useEffect to set default country when countryList is loaded
  useEffect(() => {
    if (countryList.length > 0) {
      const firstCountry = countryList[0];
      setSelectedCountry(firstCountry);
      // Set the first operator as default if available
      const firstOperator = firstCountry?.operatorList?.[0];
      setFilters(prev => ({
        ...prev,
        countryCode: firstCountry.cnUniId,
        operatorCode: firstOperator ? firstOperator.opUniId : "All"
      }));
      fetchMidDashboardData({
        ...filters,
        countryCode: firstCountry.cnUniId,
        operatorCode: firstOperator ? firstOperator.opUniId : "All"
      });
    }
  }, [countryList]);

  return <>

  <div className="card mb-4 contop_card p-3 p-md-4">
        <div className="pb-4">
          <div className="">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
              <div className="d-flex gap-2 mb-2 mb-md-0 width">
                <div className="form-group position-relative w-50">
                <label class="">Select Countries<sup class="text-danger">*</sup></label>
                  <select
                    className="form-select"
                    name="countryCode"
                    value={selectedCountry?.countryName || ""}
                    onChange={handleFilterChange}
                    disabled={isFilterLoading}
                  >
                    {countryList.map((country) => (
                      <option
                        key={country.id}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </option>
                    ))}
                  </select>
                  {isFilterLoading && <div className="select-loader mt-3 me-1"></div>}
                </div>
                <div className="form-group position-relative w-50">
                <label class="">Select Operators<sup class="text-danger">*</sup></label>

                  <select
                    className="form-select"
                    name="operatorCode"
                    value={selectedCountry?.operatorList?.find(op => op.opUniId === filters.operatorCode)?.operatorName || "All"}
                    onChange={handleFilterChange}
                    disabled={isFilterLoading || filters.countryCode === "All"}
                  >
                    <option value="All">All Operators</option>
                    {selectedCountry?.operatorList?.map((operator) => (
                      <option key={operator.id} value={operator.operatorName}>
                        {operator.operatorName}
                      </option>
                    ))}
                  </select>
                  {isFilterLoading && <div className="select-loader mt-3 me-1"></div>}
                </div>
              </div>

              <div className="d-flex align-items-center gap-1 gap-md-2 dates ps-md-2">
                <div className="form-group position-relative w-50" style={{cursor: 'pointer'}}>
                <label class="">Start Date<sup class="text-danger">*</sup></label>

                  <i className="fas fa-calendar position-absolute" style={{ right: '10px', top: '68%', transform: 'translateY(-50%)', zIndex: 1, pointerEvents: 'none', cursor: 'pointer' }}></i>
                  <DatePicker
                    selected={filters.startDate ? new Date(filters.startDate) : null}
                    onChange={(date) => {
                      handleFilterChange({
                        target: {
                          name: 'startDate',
                          value: date ? date.toISOString().split('T')[0] : ''
                        }
                      });
                    }}
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    maxDate={new Date(filters.endDate)}
                    minDate={new Date('2025-04-18')} // Set minimum date to April 18th, 2025
                    disabled={isFilterLoading}
                    placeholderText="Select start date"
                    showMonthDropdown
                    showYearDropdown    
                    dropdownMode="select"
                  />
                  {isFilterLoading && <div className="input-loader"></div>}
                </div>

                <div>-</div>
                <div className="form-group position-relative w-50" style={{cursor: 'pointer'}}>
                <label class="">End Date<sup class="text-danger">*</sup></label>

                  <i className="fas fa-calendar position-absolute" style={{ right: '10px', top: '68%', transform: 'translateY(-50%)', zIndex: 1, pointerEvents: 'none' }}></i>
                  <DatePicker
                    selected={filters.endDate ? new Date(filters.endDate) : null}
                    onChange={(date) => {
                      handleFilterChange({
                        target: {
                          name: 'endDate',
                          value: date ? date.toISOString().split('T')[0] : ''
                        }
                      });
                    }}
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    minDate={filters.startDate ? new Date(filters.startDate) : new Date('2025-04-18')} // Set minimum date to April 18th, 2025 or start date
                    maxDate={new Date()}
                    disabled={isFilterLoading}
                    placeholderText="Select end date"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  {isFilterLoading && <div className="input-loader"></div>}
                </div>
              </div>
            </div>
            {/* <div className="col-md- d-flex justify-content-end">
            
            </div> */}
          </div>
        </div>

        {/* <div className="card mt-4"> */}
        <div className="">
          {isFilterLoading ? (
            <div className="stats-loading-overlay">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="stats-container">
              {processMidDashboardData(midDashboardData).map((stat) => (
                <div
                  className="stat-card subscriber-card"
                  key={stat.id}
                  onClick={() => handleCardClick(stat.route)}
                  style={{ cursor: 'pointer' }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                    {stat.isImage ? (
                      <img src={stat.icon} alt={stat.title} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                    ) : (
                      <i className={stat.icon}></i>
                    )}
                  </div>
                  <div className="stat-details">
                    <h3>{stat.title}</h3>
                    <p className="stat-number">
                      {formatNumber(stat.number)}
                    </p>
                    {stat.trend.isHtml ? (
                      <span
                        className={stat.trend.isUp ? "trend-up" : "trend-down"}
                        dangerouslySetInnerHTML={{ __html: stat.trend.text }}
                      />
                    ) : (
                      <span className={stat.trend.isUp ? "trend-up" : "trend-down"}>
                        {stat.trend.text}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* </div> */}
      </div>

  </>;
};

export default MidCards;